import { useGetPageBookmarks, useGetResponsesGrouped } from "../api/queries";

/**
 * Custom hook to determine if a user has any content in their toolbox for a specific module.
 * Checks for bookmarks and journal entries (responses).
 */
export function useHasToolboxContent(moduleId?: string) {
  const {
    data: bookmarks,
    isLoading: isBookmarksLoading,
    isError: isBookmarksError,
  } = useGetPageBookmarks(undefined, moduleId);

  const {
    data: responses,
    isLoading: isResponsesLoading,
    isError: isResponsesError,
  } = useGetResponsesGrouped(moduleId);

  const isLoading = isBookmarksLoading || isResponsesLoading;
  const hasError = isBookmarksError || isResponsesError;

  const hasBookmarks = bookmarks && bookmarks.length > 0;
  const hasJournalEntries = responses && responses.length > 0;

  const hasContent = hasBookmarks || hasJournalEntries;

  return {
    hasContent,
    isLoading,
    hasError,
    hasBookmarks,
    hasJournalEntries,
  };
}
